import { FunctionComponent } from "react";
import {
	ClientPath,
	PageName,
	PATH_TO_MENU_ITEM_NAME_MAP,
	PATH_TO_PAGE_NAME_MAP
} from "src/utils/routing/routes";
import { Feature } from "src/utils/feature";

interface PageMetadataOptionalParameters {
	menuIcon?: string;
}

export class PageMetadata {
	readonly Page: FunctionComponent<any>;
	readonly path: ClientPath;
	readonly pageName: PageName;
	readonly menuItemName: string;
	readonly menuIcon: string | undefined;

	readonly requiredFeatures: Feature[];

	constructor(
		Page: FunctionComponent<any>,
		path: ClientPath,
		requiredFeatures: Feature[],
		optionalParameters: PageMetadataOptionalParameters = {}
	) {
		this.Page = Page;
		this.path = path;
		this.pageName = PATH_TO_PAGE_NAME_MAP[path];
		this.menuItemName = PATH_TO_MENU_ITEM_NAME_MAP[path];

		this.requiredFeatures = requiredFeatures;

		this.menuIcon = optionalParameters.menuIcon || undefined;
	}
}
